module.exports = [
  {
    id: 'save-and-organize',
    headline: 'Collect anything',
    image: 'https://d2w9rnfcy7mm78.cloudfront.net/1586587/original_971cf68a81483a8c80a9f574a62ec24e.png',
    copy: 'Save content with the browser extension, iOS app, or via email.',
  },
  {
    id: 'learn-from-links',
    headline: 'Make connections',
    image: 'https://d2w9rnfcy7mm78.cloudfront.net/1819604/original_ab9278398679a8b336190f220aea0649.png',
    copy: 'Find inspiration and save other members’ channels.',
  },
  {
    id: 'build-ideas-together',
    headline: 'Think better together',
    image: 'https://d2w9rnfcy7mm78.cloudfront.net/3676168/original_9074aa645a7cb6f73ca76c4d5e18f96d.png?1550538069',
    copy: 'Share ideas with team profiles and advanced permissions.',
  },
]